import { render, staticRenderFns } from "./PdfPageViewer.vue?vue&type=template&id=35e0f028&scoped=true&"
import script from "./PdfPageViewer.vue?vue&type=script&lang=js&"
export * from "./PdfPageViewer.vue?vue&type=script&lang=js&"
import style0 from "./PdfPageViewer.vue?vue&type=style&index=0&id=35e0f028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e0f028",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSheet,VSlider,VSpacer})
